import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EventDetails } from '../../data-access/models/eventDetails.model';

@Component({
    selector: 'app-rsvp-dialog',
    templateUrl: './rsvp-dialog.component.html',
    styleUrl: './rsvp-dialog.component.scss',
    standalone: false
})
export class RsvpDialogComponent implements OnInit {
  dietaryOptions: string[] = [];
  selectedDietary: string = '';
  existingAllergies: string = '';
  currentLocation: string = '';
  currentNotes: string = '';
  form!: FormGroup;
  isEdit: boolean = false;
  allowDietaryRequirements: boolean = false;
  allowNotes: boolean = false;
  locations!: string[];

  constructor(
    public dialogRef: MatDialogRef<RsvpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    if (!!this.data) {
      if (this.data.isEdit) {
        const event: EventDetails = data.event;
        this.dietaryOptions = event.dietaryOptions!;
        this.selectedDietary = event.rsvpDetails!.dietaryRequirements;
        this.existingAllergies = event.rsvpDetails!.allergies;
        this.currentLocation = event.rsvpDetails!.location;
        this.currentNotes = event.rsvpDetails!.notes;
        this.allowDietaryRequirements = event.allowDietaryRequirements!;
        this.allowNotes = event.allowNotes!;
        this.locations = event.locations.map(loc => loc.location);
      } else {
        this.dietaryOptions = data.dietaryOptions;
        this.selectedDietary = data.dietary;
        this.existingAllergies = data.allergies;
        this.allowDietaryRequirements = data.allowDietaryRequirements;
        this.allowNotes = data.allowNotes;
        this.locations =data.locationNames.split(',').map((location: string) => location.trim());
      }
    }
  }

  ngOnInit(): void {
    if (!!this.data) {
      if (this.data.isEdit) {
        this.form = this.fb.group({
          location: [this.currentLocation, Validators.required],
          dietary: [this.selectedDietary, this.allowDietaryRequirements ? Validators.required : []],
          allergies: [this.getAllergies(this.existingAllergies)],
          notes: [this.currentNotes]
        });
      } else {
        this.form = this.fb.group({
          location: ['', Validators.required],
          dietary: [this.selectedDietary, this.allowDietaryRequirements ? Validators.required : []],
          allergies: [this.getAllergies(this.existingAllergies)],
          notes: ['']
        });
      }
    }
  }

  getAllergies(allergy: string) {
    return allergy !== 'N/A'? allergy : '';
  }

  close(): void {
    this.dialogRef.close();
  }

  decline(): void {
    this.dialogRef.close({ accepted: false, ...this.form.value });
  }

  accept(): void {
    if (this.form.valid) {
      this.dialogRef.close({ accepted: true, ...this.form.value });
    }
  }
}
